module.exports = __webpack_public_path__ + "static/media/tree_16.624e10bd.jpg";